import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppDisclaimer = _resolveComponent("AppDisclaimer")!
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_LoadingPageDesktop = _resolveComponent("LoadingPageDesktop")!

  return (_ctx.showNewDisclaimer)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AppDisclaimer, { query: _ctx.paramsForNewDisclaimer }, null, 8, ["query"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_LoadingPage, {
                isLoadingDone: _ctx.isLoadingDone,
                buttonUrl: _ctx.buttonUrl,
                logoGuid: _ctx.logoGuid
              }, null, 8, ["isLoadingDone", "buttonUrl", "logoGuid"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_LoadingPageDesktop, {
                isLoadingDone: _ctx.isLoadingDone,
                buttonUrl: _ctx.buttonUrl,
                logoGuid: _ctx.logoGuid
              }, null, 8, ["isLoadingDone", "buttonUrl", "logoGuid"])
            ]))
      ]))
}